import type { ParentType as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { RiskAssessmentResultControlType as Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { useGetAssessmentResultsByParentId } from 'src/hooks/queries/assessment-result/useGetAssessmentResultsByParentId';

import { getFriendlyId } from '@/utils/friendlyId';

import type {
  AssessmentResultFields,
  AssessmentResultPresentationFields,
} from './types';

type GetAssessmentResultsByParentIdData = NonNullable<
  ReturnType<typeof useGetAssessmentResultsByParentId>['data']
>;

export const getParentTitle = (record: AssessmentResultFields) => {
  switch (record.typename) {
    case 'document_assessment_result':
      return (
        (
          record as Partial<
            Omit<
              GetAssessmentResultsByParentIdData['document_assessment_result'][0],
              'files'
            >
          >
        ).parents?.[0]?.document?.Title ??
        getFriendlyId(
          record.parents?.[0]?.node?.ObjectType as Parent_Type_Enum,
          record.parents?.[0]?.node?.SequentialId
        )
      );
    case 'obligation_assessment_result':
      return (
        (
          record as Partial<
            Omit<
              GetAssessmentResultsByParentIdData['obligation_assessment_result'][0],
              'files'
            >
          >
        ).parents?.[0]?.obligation?.Title ??
        getFriendlyId(
          record.parents?.[0]?.node?.ObjectType as Parent_Type_Enum,
          record.parents?.[0]?.node?.SequentialId
        )
      );
    case 'risk_assessment_result':
      return (
        (
          record as Partial<
            Omit<
              GetAssessmentResultsByParentIdData['risk_assessment_result'][0],
              'files'
            >
          >
        ).parents?.[0]?.risk?.Title ??
        getFriendlyId(
          record.parents?.[0]?.node?.ObjectType as Parent_Type_Enum,
          record.parents?.[0]?.node?.SequentialId
        )
      );
    case 'test_result':
      return (
        (
          record as Partial<
            Omit<GetAssessmentResultsByParentIdData['test_result'][0], 'files'>
          >
        )?.parent?.Title ?? '-'
      );
  }
};

export const decorateWithControlType = (
  value: string,
  getControlTypeLabel: (
    controlType: Risk_Assessment_Result_Control_Type_Enum
  ) => string,
  record: AssessmentResultPresentationFields
) => {
  if (record.typename === 'risk_assessment_result') {
    return `${value} - ${getControlTypeLabel(
      (
        record as Partial<
          Omit<
            GetAssessmentResultsByParentIdData['risk_assessment_result'][0],
            'files'
          >
        >
      ).ControlType!
    )}`;
  }

  return value;
};
